import React from 'react';
import styledFuncs from 'app/styles/styledFuncs';
import IconLib from 'app/shared/components/icon/icon-lib';
import Icon from 'app/shared/components/icon/Icon';
import styled from 'styled-components/macro';
import { NotificationCalendarData } from 'app/core/api/company/api-company.types';
import { useHistory } from 'react-router-dom';
import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import { useReadNotification } from 'app/core/api/company/api-company';
import AppImage from 'app/shared/components/app-image/AppImage';
import { DefaultUserImg } from 'app/shared/components/misc';

// const LinksContainer = styled.div`
//   border: 1px solid #eaeaea;
//   border-radius: 10px;
//   padding: 10px;
// `;

const LinkButton = styled.a`
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  display: block;
  margin: 10px !important;
  padding: 10px;
  color: black;
  b {
    font-size: 13px;
    font-weight: bold;
    display: block;
    color: black;
  }
  text {
    font-size: 10px;
    color: black;
  }
`;
const LinkRightIcon = styled(Icon).attrs({
  icon: IconLib.CHEVRON_RIGHT,
})`
  position: absolute;
  right: ${styledFuncs.pad(4)};
  margin-top: -75px;
`;

type Props = {
  data: NotificationCalendarData[];
};

export default function CalendarInfo({ data }: Props): JSX.Element {
  const history = useHistory();
  const { request$: readNotification$ } = useReadNotification();
  const DirectToCalendar = (id: number) => {
    readNotification$(id).subscribe();
    history.push(`${BusinessRoutePath.REPAIR_CALENDAR_DETAIL}/${id}`);
  };
  return (
    <>
      {data.map(val => (
        // <LinksContainer
        //   color="default"
        //   key={val.customerName}
        //   onClick={() => DirectToCalendar(val.id)}
        // >
        //   <Box display="flex">
        //     <Box display="flex" flexDirection="column" />
        //   </Box>
        //   <Subheading centered={false}>{val.type}</Subheading>
        //   <div>
        //     <Body small>{val.customerName}</Body>
        //   </div>
        //   <div>
        //     <Body small>{val.date}</Body>
        //   </div>
        //   <div>
        //     <Body small> {val.time}</Body>
        //   </div>
        // </LinksContainer>
        <LinkButton
          color="default"
          key={val.customerName}
          onClick={() => DirectToCalendar(val.id)}
        >
          <AppImage
            alt="profile image"
            src={val.imageUrl}
            fallbackImgNode={<DefaultUserImg size={60} />}
            height="60px"
            noPad
            className="mb-1.5 w-10 h-10 rounded"
          />
          <LinkRightIcon size={30} />
          <div style={{ marginLeft: '105px', marginTop: '-100px' }}>
            <b style={{ fontWeight: 600 }}>{val.type}</b>
            <text>{val.customerName}</text>
            <br />
            <text>{val.date}</text>
            <br />
            <text>{val.time}</text>
          </div>
        </LinkButton>
      ))}
    </>
  );
}
